let url = window.location.host;//域名
let DOMAIN_URL="bk";
// 请求目标服务器域名配置
const DOMAIN_NAME = {
    AI_URL: 'wss://api.acme-ai.com/asr',          // ai调用域名
    AI_URL_TTS: 'https://api.acme-ai.com/asr',    // rtc正式环境
    smartPitchId: '北控弘赫基地',    // 智慧球场
    smartPitchUrl: 'https://fc.acme-ai.com/smart_pitch', // 智慧球场
    URL_CNODEJS: 'https://api.acme-ai.com/bk/webapi/basketball',    // 正式环境
    TEST_URL_CNODEJS: 'https://api.test.acme-ai.com/bk/webapi/basketball',    // 测试环境
};
export default {
    DOMAIN_NAME,
    DOMAIN_URL
};
